const ALLOWED_TENANT_DOMAINS = [
  /\.qlikcloud\.com$/,
  /\.qlik-stage\.com$/,
  /\.qlikcloudgov\.com$/,
  /\.qlik-stagegov\.com$/,
  /\.qlikdev\.com$/,
];

function isAllowedHost(hostname) {
  if (hostname === 'elastic.example') return true;
  return ALLOWED_TENANT_DOMAINS.some((re) => re.test(hostname));
}

module.exports = function () {
  const url = new URL(location.href);

  // this should correspond to the QCS tenant URL
  const tenantUrl = url.searchParams.get('tenant') || 'https://elastic.example';

  // this should correspond to an web integration id that:
  // 1) exists in the `tenantUrl` above (create a new one using Management Console -> Integrations)
  // 2) has the domain for this mashup in its whitelisted domain
  const webIntegrationId =
    url.searchParams.get('wiid') || 'web-integration-id-here';

  // should be Helpdesk Management resourceId:
  const appId = url.searchParams.get('app');
  const theme = url.searchParams.get('theme');

  const tenant = new URL(tenantUrl);
  if (!isAllowedHost(tenant.hostname)) {
    throw new Error(`Untrusted tenant host rejected: ${tenant.hostname}`);
  }
  return {
    host: tenant.hostname,
    port: tenant.port || 443,
    isSecure: true,
    prefix: '/',
    webIntegrationId,
    appId,
    theme,
  };
};
